import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from "@radix-ui/react-icons";
import { Link } from "@tanstack/react-router";
import { ExperienceGridCard } from "./ExperienceGridCard";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ExperiencesGrid(t0) {
  const $ = _c(16);
  const {
    title,
    experiences,
    size: t1,
    categorySlug
  } = t0;
  const size = t1 === undefined ? "regular" : t1;
  let t2;
  if ($[0] !== categorySlug || $[1] !== title) {
    t2 = () => {
      if (!title) {
        return null;
      }
      if (categorySlug) {
        return /*#__PURE__*/_jsxs(Link, {
          to: "/upplevelser/$slug",
          params: {
            slug: categorySlug
          },
          className: "group mb-6 flex items-center gap-2 hover:text-primary",
          children: [/*#__PURE__*/_jsx("h2", {
            className: "text-2xl font-bold transition-colors group-hover:text-primary",
            children: title
          }), /*#__PURE__*/_jsx(ChevronRightIcon, {
            className: "h-5 w-5 transition-transform group-hover:translate-x-1"
          })]
        });
      }
      return /*#__PURE__*/_jsx("h2", {
        className: "mb-6 text-2xl font-bold",
        children: title
      });
    };
    $[0] = categorySlug;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const TitleComponent = t2;
  let t3;
  if ($[3] !== TitleComponent || $[4] !== title) {
    t3 = title && /*#__PURE__*/_jsx("div", {
      className: "mx-auto mb-6 max-w-[1200px]",
      children: /*#__PURE__*/_jsx(TitleComponent, {})
    });
    $[3] = TitleComponent;
    $[4] = title;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== experiences || $[7] !== size) {
    let t5;
    if ($[9] !== size) {
      t5 = experience => /*#__PURE__*/_jsx("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/_jsx("div", {
          className: "w-full max-w-[200px] sm:max-w-[225px] md:max-w-[250px]",
          children: /*#__PURE__*/_jsx(ExperienceGridCard, {
            experience: experience,
            size: size
          })
        })
      }, experience.id);
      $[9] = size;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = experiences.map(t5);
    $[6] = experiences;
    $[7] = size;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = /*#__PURE__*/_jsx("div", {
      className: "mx-auto max-w-[1200px]",
      children: /*#__PURE__*/_jsx("div", {
        className: "grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
        children: t4
      })
    });
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = /*#__PURE__*/_jsxs("div", {
      className: "w-full",
      children: [t3, t5]
    });
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}